import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import api from "./api";
import { Table } from "react-bootstrap";

import { ButtonGroup } from "react-bootstrap";
import { Button } from "react-bootstrap";
import { Accordion } from "react-bootstrap";
import { Card } from "react-bootstrap";
import { Form } from "react-bootstrap";
import sortObjects from "sort-objects-array";

function Result() {
  const [orgs, setOrgs] = useState([]);
  const [view, setView] = useState([]);
  const [states, setStates] = useState([]);
  const [countries, setCountries] = useState([]);
  const [searchResult, setSearchResult] = useState([]);
  const [activeStateList, setActiveStateList] = useState([]);
  const [activeCountryList, setActiveCountryList] = useState([]);
  const [alphabetical, setAlphabetical] = useState(true);
  const [domesticViewState, setdomesticViewState] = useState(false);
  const [alphabeticalCountry, setAlphabeticalCountry] = useState(true);
  const [domesticViewCountry, setdomesticViewCountry] = useState(false);
  const [foregin, setForegin] = useState([]);
  const [userinput, setUserinput] = useState("");
  const [noResultText, setNoResultText] = useState("");
  const [clearSearchShow, setClearSearchShow] = useState(false);
  const [alphabeticalDomesticSort, setAlphabeticalDomesticSort] = useState(
    false
  );
  const [
    alphabeticalDomesticSortbyAssurance,
    setAlphabeticalDomesticSortAssurance,
  ] = useState(false);

  const [alphabeticalForeignSort, setAlphabeticalForeignSort] = useState(false);
  const [
    alphabeticalForeignSortbyAssurance,
    setAlphabeticalForeignSortbyAssurance,
  ] = useState(false);

  const [alphabeticalAllSort, setAlphabeticalAllSort] = useState(false);
  const [
    alphabeticalAllSortbyAssurance,
    setAlphabeticalAllSortbyAssurance,
  ] = useState(false);
  const [
    alphabeticalAllSortbyOrgname,
    setAlphabeticalAllSortbyOrgname,
  ] = useState(false);

  const [preselected, setPreselected] = useState("none");
  const [preselectedTab, setPreselectedTab] = useState("none");

  const [key, setKey] = useState("DOMESTIC");

  useEffect(() => {
    axios.get(api).then(function (res) {
      let currentUrl = document.URL;
      if (currentUrl.indexOf("#") !== -1) {
        currentUrl = currentUrl.split("#");
        currentUrl = currentUrl[1];
        setPreselected(currentUrl);
      }

      var all_orgs = sortObjects(res.data, "ORGCOUNTRY", "asc");
      setOrgs(all_orgs);

      var filtered_orgs = res.data.filter(function (org) {
        return org.ORGCOUNTRY == "United States";
      });

      var filtered_orgs = sortObjects(filtered_orgs, "ORGNAME", "asc");
      setView(filtered_orgs);

      let states = [];
      let countries = [];
      let foreign_countries = [];
      let allList = [];
      for (let i = 0; i < res.data.length; i++) {
        var full_org = res.data[i];
        if (full_org.LEGACY_ASSURANCE_ID !== null) {
          full_org.full = full_org.ASSURANCE_ID + full_org.LEGACY_ASSURANCE_ID;
        } else {
          full_org.full = full_org.ASSURANCE_ID;
        }
        full_org.full =
          (full_org.ORGNAME !== null ? full_org.ORGNAME.toLowerCase() : "") +
          " " +
          (full_org.ORGCITY !== null ? full_org.ORGCITY.toLowerCase() : "") +
          " " +
          (full_org.ORGSTATE !== null ? full_org.ORGSTATE.toLowerCase() : "") +
          " " +
          (full_org.ORGCOUNTRY !== null
            ? full_org.ORGCOUNTRY.toLowerCase()
            : "") +
          " " +
          (full_org.ASSURANCE_ID !== null
            ? full_org.ASSURANCE_ID.toLowerCase()
            : "") +
          " " +
          (full_org.LEGACY_ASSURANCE_ID !== null
            ? full_org.LEGACY_ASSURANCE_ID.toLowerCase()
            : "");

        allList.push(full_org);
        if (res.data[i].ORGCOUNTRY == "United States") {
          if (states.length > 0) {
            for (let x = 0; x < states.length; x++) {
              if (res.data[i].ORGSTATE === states[x].state) {
                for (let c = 0; c < states[x].org.length; c++) {
                  if (
                    states[x].org[c].ASSURANCE_ID + states[x].org[c].ORGNAME ==
                    res.data[i].ASSURANCE_ID + res.data[i].ORGNAME
                  ) {
                    continue;
                  } else {
                    if (c == states[x].org.length - 1) {
                      states[x].org.push(res.data[i]);
                    }
                  }
                }
                break;
              } else {
                if (x == states.length - 1) {
                  let obj = {};
                  obj.state = res.data[i].ORGSTATE;
                  obj.org = [];
                  obj.org.push(res.data[i]);
                  if (obj.state != null) {
                    obj.abv = obj.state.charAt(0);
                    states.push(obj);
                  }
                }
              }
            }
          } else {
            let obj = {};
            obj.state = res.data[i].ORGSTATE;
            obj.org = [];
            obj.org.push(res.data[i]);
            if (obj.state != null) {
              obj.abv = obj.state.charAt(0);
              states.push(obj);
            }
          }
        } else {
          if (res.data[i].ORGCOUNTRY != null) {
            foreign_countries.push(res.data[i]);
            if (countries.length > 0) {
              for (let x = 0; x < countries.length; x++) {
                if (res.data[i].ORGCOUNTRY === countries[x].country) {
                  for (let c = 0; c < countries[x].org.length; c++) {
                    if (
                      countries[x].org[c].ASSURANCE_ID +
                        countries[x].org[c].ORGNAME ==
                      res.data[i].ASSURANCE_ID + res.data[i].ORGNAME
                    ) {
                      continue;
                    } else {
                      if (c == countries[x].org.length - 1) {
                        countries[x].org.push(res.data[i]);
                      }
                    }
                  }
                  break;
                } else {
                  if (x == countries.length - 1) {
                    let obj = {};
                    obj.country = res.data[i].ORGCOUNTRY;
                    obj.org = [];
                    obj.org.push(res.data[i]);
                    if (obj.country != null) {
                      obj.abv = res.data[i].ORGCOUNTRY.charAt(0);
                      countries.push(obj);
                    }
                  }
                }
              }
            } else {
              let obj = {};
              obj.country = res.data[i].ORGCOUNTRY;
              obj.org = [];
              obj.org.push(res.data[i]);
              if (obj.country != null) {
                obj.abv = res.data[i].ORGCOUNTRY.charAt(0);
                countries.push(obj);
              }
            }
          }
        }
      }

      var sorted_states = [];
      for (let v = 0; v < states.length; v++) {
        var state = states[v];
        state.org = sortObjects(states[v].org, "ORGNAME", "asc");
        sorted_states.push(state);
      }

      setStates(sorted_states);

      var sorted_countries = [];
      for (let v = 0; v < countries.length; v++) {
        var country = countries[v];
        country.org = sortObjects(countries[v].org, "ORGNAME", "asc");
        sorted_countries.push(country);
      }
      setCountries(sorted_countries);

      foreign_countries = sortObjects(foreign_countries, "ORGNAME", "asc");
      setForegin(foreign_countries);
      var state_list = states.filter(function (state) {
        return state.abv == "A";
      });
      var country_list = countries.filter(function (country) {
        return country.abv == "A";
      });
      setActiveStateList(state_list);
      setActiveCountryList(country_list);
    });
  }, []);

  function getActiveState(abv) {
    var state_list = states.filter(function (state) {
      return state.abv == abv;
    });

    var states_sorted_all = sortObjects(state_list, "state", "asc");
    setActiveStateList(states_sorted_all);
  }

  function getActiveCountry(abv) {
    var country_list = countries.filter(function (country) {
      return country.abv == abv;
    });

    var countries_sorted_all = sortObjects(country_list, "country", "asc");
    setActiveCountryList(countries_sorted_all);
  }

  function setViewAlphabetical() {
    setAlphabetical(true);
    setdomesticViewState(false);
  }

  function setViewState() {
    getActiveState("A");
    setdomesticViewState(true);
    setAlphabetical(false);
  }

  function setViewAlphabeticalCountry() {
    setAlphabeticalCountry(true);
    setdomesticViewCountry(false);
  }

  function setViewCountry() {
    getActiveCountry("A");
    setdomesticViewCountry(true);
    setAlphabeticalCountry(false);
  }

  function userInput(e) {
    setUserinput(e.target.value);
  }

  function handleSearch(e) {
    e.preventDefault();
    setNoResultText("No Result");
    setClearSearchShow(true);
    var user_input = userinput.toLowerCase();
    user_input = user_input.replace(/\s/g, " ");
    user_input = user_input.replace(/\(/g, "");
    user_input = user_input.replace(/\)/g, "");
    let fitered = orgs.filter((org) => {
      return org.full.includes(user_input);
    });
    fitered = sortObjects(fitered, "ORGNAME", "asc");

    setSearchResult(fitered);
  }

  function clearSearch() {
    setSearchResult([]);
    setNoResultText("");
    setClearSearchShow(false);
    document.getElementById("searchbox").value = "";
  }

  function sortDomesticList() {
    var orgs = view;
    if (alphabeticalDomesticSort) {
      orgs = sortObjects(view, "ORGNAME", "asc");
      setAlphabeticalDomesticSort(false);
    } else {
      orgs = sortObjects(view, "ORGNAME", "desc");
      setAlphabeticalDomesticSort(true);
    }
    setView(orgs);
  }

  function sortDomesticListbyAssurance() {
    var orgs = view;
    if (alphabeticalDomesticSortbyAssurance) {
      orgs = sortObjects(view, "ASSURANCE_ID", "asc");
      setAlphabeticalDomesticSortAssurance(false);
    } else {
      orgs = sortObjects(view, "ASSURANCE_ID", "desc");
      setAlphabeticalDomesticSortAssurance(true);
    }
    setView(orgs);
  }

  function sortForeignList() {
    var orgs = foregin;
    if (alphabeticalForeignSort) {
      orgs = sortObjects(foregin, "ORGNAME", "asc");
      setAlphabeticalForeignSort(false);
    } else {
      orgs = sortObjects(foregin, "ORGNAME", "desc");
      setAlphabeticalForeignSort(true);
    }
    setForegin(orgs);
  }

  function sortForeignListbyAssurance() {
    var orgs = foregin;
    if (alphabeticalForeignSortbyAssurance) {
      orgs = sortObjects(foregin, "ASSURANCE_ID", "asc");
      setAlphabeticalForeignSortbyAssurance(false);
    } else {
      orgs = sortObjects(foregin, "ASSURANCE_ID", "desc");
      setAlphabeticalForeignSortbyAssurance(true);
    }
    setForegin(orgs);
  }

  function sortAllList() {
    if (alphabeticalAllSort) {
      var sorted_orgs = sortObjects(orgs, "ORGCOUNTRY", "asc");
      setAlphabeticalAllSort(false);
    } else {
      var sorted_orgs = sortObjects(orgs, "ORGCOUNTRY", "desc");
      setAlphabeticalAllSort(true);
    }
    setOrgs(sorted_orgs);
  }

  function sortAllListbyAssurance() {
    if (alphabeticalAllSortbyAssurance) {
      var sorted_orgs = sortObjects(orgs, "ASSURANCE_ID", "asc");
      setAlphabeticalAllSortbyAssurance(false);
    } else {
      var sorted_orgs = sortObjects(orgs, "ASSURANCE_ID", "desc");
      setAlphabeticalAllSortbyAssurance(true);
    }
    setOrgs(sorted_orgs);
  }

  function sortAllListbyOrgname() {
    if (alphabeticalAllSortbyOrgname) {
      var sorted_orgs = sortObjects(orgs, "ORGNAME", {
        order: "asc",
        caseinsensitive: true,
      });
      setAlphabeticalAllSortbyOrgname(false);
    } else {
      var sorted_orgs = sortObjects(orgs, "ORGNAME", {
        order: "desc",
        caseinsensitive: true,
      });
      setAlphabeticalAllSortbyOrgname(true);
    }
    setOrgs(sorted_orgs);
  }

  return (
    <div>
      <h2 style={{ textAlign: "left" }}>
        Institutions with a PHS Approved Animal Welfare Assurance
      </h2>
      <form>
        <Form.Control
          placeholder="Search"
          id="searchbox"
          style={{ width: "100%", float: "left" }}
          onChange={(e) => {
            userInput(e);
          }}
        />
        <Button
          variant="primary"
          type="submit"
          style={{ width: "80px", marginLeft: "-80px" }}
          onClick={(e) => handleSearch(e)}
        >
          Search
        </Button>
      </form>
      <br />
      {clearSearchShow ? (
        <div style={{ textAlign: "left" }}>
          <span
            style={{ color: "red", cursor: "pointer", fontWeight: "800" }}
            onClick={clearSearch}
          >
            X
          </span>{" "}
          Clear search term: {'"' + userinput + '"'}
        </div>
      ) : (
        ""
      )}

      {searchResult.length > 0 ? (
        <div>
          <hr />
          <div style={{ textAlign: "left", margin: "0px 10px 15px 10px" }}>
            Total Results : {searchResult.length}
          </div>
          <div style={{ textAlign: "center" }}>
            <Table
              striped
              bordered
              hover
              style={{ width: "98%", display: "table" }}
            >
              <thead>
                <tr>
                  <th style={{ width: "30%", textAlign: "left" }}>
                    State/Country
                  </th>
                  <th style={{ width: "40%", textAlign: "left" }}>
                    Organization Name
                  </th>
                  <th style={{ width: "30%", textAlign: "left" }}>
                    Assurance ID (Legacy Assurance ID)
                  </th>
                </tr>
              </thead>
              <tbody>
                {searchResult.map(function (item) {
                  return (
                    <tr>
                      {item.ORGCOUNTRY === "United States" ? (
                        <td
                          style={{
                            width: "30%",
                            textAlign: "left",
                            lineHeight: "20px",
                            fontSize: "1em",
                          }}
                        >
                          {item.ORGSTATE}/{item.ORGCOUNTRY}
                        </td>
                      ) : (
                        <td
                          style={{
                            width: "30%",
                            textAlign: "left",
                            lineHeight: "20px",
                            fontSize: "1em",
                          }}
                        >
                          {item.ORGCOUNTRY}
                        </td>
                      )}

                      <td
                        style={{
                          width: "40%",
                          textAlign: "left",
                          lineHeight: "20px",
                          fontSize: "1em",
                        }}
                      >
                        {item.ORGNAME}
                      </td>

                      {item.LEGACY_ASSURANCE_ID !== null ? (
                        <td
                          style={{
                            width: "30%",
                            textAlign: "left",
                            lineHeight: "20px",
                            fontSize: "1em",
                          }}
                        >
                          {item.ASSURANCE_ID} ({item.LEGACY_ASSURANCE_ID})
                        </td>
                      ) : (
                        <td
                          style={{
                            width: "30%",
                            textAlign: "left",
                            lineHeight: "20px",
                            fontSize: "1em",
                          }}
                        >
                          {item.ASSURANCE_ID}
                        </td>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </Table>
            <br />

            <div style={{ textAlign: "left" }}>End of results</div>
          </div>
          <hr />
        </div>
      ) : (
        <div style={{ textAlign: "left", fontSize: "2em" }}>{noResultText}</div>
      )}

      <br />

      <ul className="nav nav-tabs" role="tablist">
        {preselected == "DOMESTIC" || preselected == "none" ? (
          <li className="active">
            <a href="#DOMESTIC" role="tab" data-toggle="tab">
              DOMESTIC
            </a>
          </li>
        ) : (
          <li>
            <a href="#DOMESTIC" role="tab" data-toggle="tab">
              DOMESTIC
            </a>
          </li>
        )}
        {preselected == "FOREIGN" ? (
          <li className="active">
            <a href="#FOREIGN" role="tab" data-toggle="tab">
              FOREIGN
            </a>
          </li>
        ) : (
          <li>
            <a href="#FOREIGN" role="tab" data-toggle="tab">
              FOREIGN
            </a>
          </li>
        )}
        {preselected == "ALL" ? (
          <li className="active">
            <a href="#ALL" role="tab" data-toggle="tab">
              VIEW ALL
            </a>
          </li>
        ) : (
          <li>
            <a href="#ALL" role="tab" data-toggle="tab">
              VIEW ALL
            </a>
          </li>
        )}
      </ul>

      <div className="tab-content">
        <div
          className={
            preselected == "DOMESTIC" || preselected == "none"
              ? "tab-pane fade active in"
              : "tab-pane fade"
          }
          id="DOMESTIC"
        >
          <div style={{ textAlign: "left", margin: "0px 10px 10px 10px" }}>
            <div className="btn-group" role="group" aria-label="Category">
              <button
                type="button"
                className="btn btn-default"
                onClick={setViewAlphabetical}
              >
                ALPHABETICAL
              </button>
              <button
                type="button"
                className="btn btn-default"
                onClick={setViewState}
              >
                BY STATE
              </button>
            </div>
          </div>

          {alphabetical ? (
            <div>
              <div style={{ textAlign: "left", margin: "0px 10px 15px 10px" }}>
                Total : {view.length}
              </div>
              <div style={{ textAlign: "center" }}>
                <Table striped bordered hover style={{ display: "table" }}>
                  <thead>
                    <tr>
                      <th style={{ width: "50%", textAlign: "left" }}>
                        Organization Name
                        {alphabeticalDomesticSort ? (
                          <span
                            style={{ marginLeft: "5px", cursor: "pointer" }}
                            onClick={sortDomesticList}
                          >
                            &#8593;
                          </span>
                        ) : (
                          <span
                            style={{ marginLeft: "5px", cursor: "pointer" }}
                            onClick={sortDomesticList}
                          >
                            &#8595;
                          </span>
                        )}
                      </th>
                      <th style={{ width: "50%", textAlign: "left" }}>
                        Assurance ID (Legacy Assurance ID)
                        {alphabeticalDomesticSortbyAssurance ? (
                          <span
                            style={{ marginLeft: "5px", cursor: "pointer" }}
                            onClick={sortDomesticListbyAssurance}
                          >
                            &#8593;
                          </span>
                        ) : (
                          <span
                            style={{ marginLeft: "5px", cursor: "pointer" }}
                            onClick={sortDomesticListbyAssurance}
                          >
                            &#8595;
                          </span>
                        )}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {view.map(function (item) {
                      return (
                        <tr>
                          <td
                            style={{
                              width: "50%",
                              textAlign: "left",
                              lineHeight: "20px",
                              fontSize: "1em",
                            }}
                          >
                            {item.ORGNAME}
                          </td>

                          {item.LEGACY_ASSURANCE_ID !== null ? (
                            <td
                              style={{
                                width: "50%",
                                textAlign: "left",
                                lineHeight: "20px",
                                fontSize: "1em",
                              }}
                            >
                              {item.ASSURANCE_ID} ({item.LEGACY_ASSURANCE_ID})
                            </td>
                          ) : (
                            <td
                              style={{
                                width: "50%",
                                textAlign: "left",
                                lineHeight: "20px",
                                fontSize: "1em",
                              }}
                            >
                              {item.ASSURANCE_ID}
                            </td>
                          )}
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            </div>
          ) : (
            <div>
              <div style={{ textAlign: "left", marginLeft: "25px" }}>
                <ButtonGroup aria-label="StateLetters">
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={() => getActiveState("A")}
                  >
                    A
                  </button>
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={() => getActiveState("B")}
                  >
                    B
                  </button>
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={() => getActiveState("C")}
                  >
                    C
                  </button>
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={() => getActiveState("D")}
                  >
                    D
                  </button>
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={() => getActiveState("E")}
                  >
                    E
                  </button>
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={() => getActiveState("F")}
                  >
                    F
                  </button>
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={() => getActiveState("G")}
                  >
                    G
                  </button>
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={() => getActiveState("H")}
                  >
                    H
                  </button>
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={() => getActiveState("I")}
                  >
                    I
                  </button>
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={() => getActiveState("J")}
                  >
                    J
                  </button>
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={() => getActiveState("K")}
                  >
                    K
                  </button>
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={() => getActiveState("L")}
                  >
                    L
                  </button>
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={() => getActiveState("M")}
                  >
                    M
                  </button>
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={() => getActiveState("N")}
                  >
                    N
                  </button>
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={() => getActiveState("O")}
                  >
                    O
                  </button>
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={() => getActiveState("P")}
                  >
                    P
                  </button>
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={() => getActiveState("Q")}
                  >
                    Q
                  </button>
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={() => getActiveState("R")}
                  >
                    R
                  </button>
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={() => getActiveState("S")}
                  >
                    S
                  </button>
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={() => getActiveState("T")}
                  >
                    T
                  </button>
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={() => getActiveState("U")}
                  >
                    U
                  </button>
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={() => getActiveState("V")}
                  >
                    V
                  </button>
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={() => getActiveState("W")}
                  >
                    W
                  </button>
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={() => getActiveState("X")}
                  >
                    X
                  </button>
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={() => getActiveState("Y")}
                  >
                    Y
                  </button>
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={() => getActiveState("Z")}
                  >
                    Z
                  </button>
                </ButtonGroup>
              </div>
              <br />
              {activeStateList.length > 0 ? (
                <ul className="list-group">
                  <Accordion style={{ width: "98%", margin: "0 auto" }}>
                    {activeStateList.map(function (item, index) {
                      return (
                        <li className="list-group-item">
                          <div>
                            <Accordion.Toggle
                              as={Card.Header}
                              eventKey={index}
                              style={{
                                textAlign: "left",
                                fontSize: "1em",
                                fontWeight: "800",
                                cursor: "pointer",
                              }}
                              className="stateHeader"
                            >
                              <div style={{ padding: "10px" }}>
                                {item.state}
                              </div>
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={index}>
                              <div style={{ width: "95%", margin: "0 auto" }}>
                                <Table
                                  striped
                                  bordered
                                  hover
                                  style={{
                                    width: "100%",
                                    display: "table",
                                    marginTop: "10px",
                                  }}
                                >
                                  <thead>
                                    <tr>
                                      <th style={{ textAlign: "left" }}>
                                        Organization Name
                                      </th>
                                      <th style={{ textAlign: "left" }}>
                                        Assurance ID (Legacy Assurance ID)
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {item.org.map(function (company) {
                                      return (
                                        <tr>
                                          <td
                                            style={{
                                              textAlign: "left",
                                              lineHeight: "20px",
                                              fontSize: "1em",
                                            }}
                                          >
                                            {company.ORGNAME}
                                          </td>
                                          {company.LEGACY_ASSURANCE_ID !==
                                          null ? (
                                            <td
                                              style={{
                                                textAlign: "left",
                                                lineHeight: "20px",
                                                fontSize: "1em",
                                              }}
                                            >
                                              {company.ASSURANCE_ID} (
                                              {company.LEGACY_ASSURANCE_ID})
                                            </td>
                                          ) : (
                                            <td
                                              style={{
                                                textAlign: "left",
                                                lineHeight: "20px",
                                                fontSize: "1em",
                                              }}
                                            >
                                              {company.ASSURANCE_ID}
                                            </td>
                                          )}
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </Table>
                              </div>
                            </Accordion.Collapse>
                          </div>
                        </li>
                      );
                    })}
                  </Accordion>
                </ul>
              ) : (
                <div>No organization found</div>
              )}
            </div>
          )}
        </div>
        <div
          className={
            preselected == "FOREIGN"
              ? "tab-pane fade active in"
              : "tab-pane fade"
          }
          id="FOREIGN"
        >
          <div style={{ textAlign: "left", margin: "0px 10px 10px 10px" }}>
            <ButtonGroup aria-label="CategoryCountry">
              <button
                type="button"
                className="btn btn-default"
                onClick={setViewAlphabeticalCountry}
              >
                ALPHABETICAL
              </button>
              <button
                type="button"
                className="btn btn-default"
                onClick={setViewCountry}
              >
                BY COUNTRY
              </button>
            </ButtonGroup>
          </div>

          {alphabeticalCountry ? (
            <div>
              <div style={{ textAlign: "left", margin: "0px 10px 15px 10px" }}>
                Total : {foregin.length}
              </div>
              <div style={{ textAlign: "center" }}>
                <Table
                  striped
                  bordered
                  hover
                  style={{ width: "98%", display: "inline-block" }}
                >
                  <thead>
                    <tr>
                      <th style={{ width: "50%", textAlign: "left" }}>
                        Organization Name
                        {alphabeticalForeignSort ? (
                          <span
                            style={{ marginLeft: "5px", cursor: "pointer" }}
                            onClick={sortForeignList}
                          >
                            &#8593;
                          </span>
                        ) : (
                          <span
                            style={{ marginLeft: "5px", cursor: "pointer" }}
                            onClick={sortForeignList}
                          >
                            &#8595;
                          </span>
                        )}
                      </th>
                      <th style={{ width: "50%", textAlign: "left" }}>
                        Assurance ID (Legacy Assurance ID)
                        {alphabeticalForeignSortbyAssurance ? (
                          <span
                            style={{ marginLeft: "5px", cursor: "pointer" }}
                            onClick={sortForeignListbyAssurance}
                          >
                            &#8593;
                          </span>
                        ) : (
                          <span
                            style={{ marginLeft: "5px", cursor: "pointer" }}
                            onClick={sortForeignListbyAssurance}
                          >
                            &#8595;
                          </span>
                        )}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {foregin.map(function (item) {
                      return (
                        <tr>
                          <td
                            style={{
                              width: "50%",
                              textAlign: "left",
                              lineHeight: "20px",
                              fontSize: "1em",
                            }}
                          >
                            {item.ORGNAME}
                          </td>

                          {item.LEGACY_ASSURANCE_ID !== null ? (
                            <td
                              style={{
                                width: "50%",
                                textAlign: "left",
                                lineHeight: "20px",
                                fontSize: "1em",
                              }}
                            >
                              {item.ASSURANCE_ID} ({item.LEGACY_ASSURANCE_ID})
                            </td>
                          ) : (
                            <td
                              style={{
                                width: "50%",
                                textAlign: "left",
                                lineHeight: "20px",
                                fontSize: "1em",
                              }}
                            >
                              {item.ASSURANCE_ID}
                            </td>
                          )}
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            </div>
          ) : (
            <div>
              <div style={{ textAlign: "left", marginLeft: "25px" }}>
                <ButtonGroup aria-label="CountryLetters">
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={() => getActiveCountry("A")}
                  >
                    A
                  </button>
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={() => getActiveCountry("B")}
                  >
                    B
                  </button>
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={() => getActiveCountry("C")}
                  >
                    C
                  </button>
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={() => getActiveCountry("D")}
                  >
                    D
                  </button>
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={() => getActiveCountry("E")}
                  >
                    E
                  </button>
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={() => getActiveCountry("F")}
                  >
                    F
                  </button>
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={() => getActiveCountry("G")}
                  >
                    G
                  </button>
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={() => getActiveCountry("H")}
                  >
                    H
                  </button>
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={() => getActiveCountry("I")}
                  >
                    I
                  </button>
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={() => getActiveCountry("J")}
                  >
                    J
                  </button>
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={() => getActiveCountry("K")}
                  >
                    K
                  </button>
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={() => getActiveCountry("L")}
                  >
                    L
                  </button>
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={() => getActiveCountry("M")}
                  >
                    M
                  </button>
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={() => getActiveCountry("N")}
                  >
                    N
                  </button>
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={() => getActiveCountry("O")}
                  >
                    O
                  </button>
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={() => getActiveCountry("P")}
                  >
                    P
                  </button>
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={() => getActiveCountry("Q")}
                  >
                    Q
                  </button>
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={() => getActiveCountry("R")}
                  >
                    R
                  </button>
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={() => getActiveCountry("S")}
                  >
                    S
                  </button>
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={() => getActiveCountry("T")}
                  >
                    T
                  </button>
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={() => getActiveCountry("U")}
                  >
                    U
                  </button>
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={() => getActiveCountry("V")}
                  >
                    V
                  </button>
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={() => getActiveCountry("W")}
                  >
                    W
                  </button>
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={() => getActiveCountry("X")}
                  >
                    X
                  </button>
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={() => getActiveCountry("Y")}
                  >
                    Y
                  </button>
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={() => getActiveCountry("Z")}
                  >
                    Z
                  </button>
                </ButtonGroup>
              </div>
              <br />
              {activeCountryList.length > 0 ? (
                <ul className="list-group">
                  <Accordion style={{ width: "98%", margin: "0 auto" }}>
                    {activeCountryList.map(function (item, index) {
                      return (
                        <li className="list-group-item">
                          <div>
                            <Accordion.Toggle
                              as={Card.Header}
                              eventKey={index}
                              style={{
                                textAlign: "left",
                                fontSize: "1em",
                                fontWeight: "800",
                                cursor: "pointer",
                              }}
                              className="stateHeader"
                            >
                              <div style={{ padding: "10px" }}>
                                {" "}
                                {item.country}{" "}
                              </div>
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={index}>
                              <div style={{ width: "95%", margin: "0 auto" }}>
                                <Table
                                  striped
                                  bordered
                                  hover
                                  style={{ maxWidth: "100%", display: "table" }}
                                >
                                  <thead>
                                    <tr>
                                      <th style={{ textAlign: "left" }}>
                                        Organization Name
                                      </th>
                                      <th style={{ textAlign: "left" }}>
                                        Assurance ID (Legacy Assurance ID)
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {item.org.map(function (company) {
                                      return (
                                        <tr>
                                          <td
                                            style={{
                                              textAlign: "left",
                                              lineHeight: "20px",
                                              fontSize: "1em",
                                            }}
                                          >
                                            {company.ORGNAME}
                                          </td>
                                          {company.LEGACY_ASSURANCE_ID !==
                                          null ? (
                                            <td
                                              style={{
                                                textAlign: "left",
                                                lineHeight: "20px",
                                                fontSize: "1em",
                                              }}
                                            >
                                              {company.ASSURANCE_ID} (
                                              {company.LEGACY_ASSURANCE_ID})
                                            </td>
                                          ) : (
                                            <td
                                              style={{
                                                textAlign: "left",
                                                lineHeight: "20px",
                                                fontSize: "1em",
                                              }}
                                            >
                                              {company.ASSURANCE_ID}
                                            </td>
                                          )}
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </Table>
                              </div>
                            </Accordion.Collapse>
                          </div>
                        </li>
                      );
                    })}
                  </Accordion>
                </ul>
              ) : (
                <div>No organization found</div>
              )}
            </div>
          )}
        </div>
        <div
          className={
            preselected == "ALL" ? "tab-pane fade active in" : "tab-pane fade"
          }
          id="ALL"
        >
          <div style={{ textAlign: "center" }}>
            <Table
              striped
              bordered
              hover
              style={{ width: "98%", display: "inline-block" }}
            >
              <thead>
                <tr>
                  <th style={{ width: "30%", textAlign: "left" }}>
                    Country
                    {alphabeticalAllSort ? (
                      <span
                        style={{ marginLeft: "5px", cursor: "pointer" }}
                        onClick={sortAllList}
                      >
                        &#8593;
                      </span>
                    ) : (
                      <span
                        style={{ marginLeft: "5px", cursor: "pointer" }}
                        onClick={sortAllList}
                      >
                        &#8595;
                      </span>
                    )}
                  </th>
                  <th style={{ width: "40%", textAlign: "left" }}>
                    Organization Name
                    {alphabeticalAllSortbyOrgname ? (
                      <span
                        style={{ marginLeft: "5px", cursor: "pointer" }}
                        onClick={sortAllListbyOrgname}
                      >
                        &#8593;
                      </span>
                    ) : (
                      <span
                        style={{ marginLeft: "5px", cursor: "pointer" }}
                        onClick={sortAllListbyOrgname}
                      >
                        &#8595;
                      </span>
                    )}
                  </th>
                  <th style={{ width: "30%", textAlign: "left" }}>
                    Assurance ID (Legacy Assurance ID)
                    {alphabeticalAllSortbyAssurance ? (
                      <span
                        style={{ marginLeft: "5px", cursor: "pointer" }}
                        onClick={sortAllListbyAssurance}
                      >
                        &#8593;
                      </span>
                    ) : (
                      <span
                        style={{ marginLeft: "5px", cursor: "pointer" }}
                        onClick={sortAllListbyAssurance}
                      >
                        &#8595;
                      </span>
                    )}
                  </th>
                </tr>
              </thead>
              <tbody>
                {orgs.map(function (item) {
                  return (
                    <tr>
                      <td
                        style={{
                          width: "20%",
                          textAlign: "left",
                          lineHeight: "20px",
                          fontSize: "1em",
                        }}
                      >
                        {item.ORGCOUNTRY}
                        {item.ORGCOUNTRY == "United States"
                          ? " / " + item.ORGSTATE
                          : ""}
                      </td>
                      <td
                        style={{
                          width: "40%",
                          textAlign: "left",
                          lineHeight: "20px",
                          fontSize: "1em",
                        }}
                      >
                        {item.ORGNAME}
                      </td>

                      {item.LEGACY_ASSURANCE_ID !== null ? (
                        <td
                          style={{
                            width: "40%",
                            textAlign: "left",
                            lineHeight: "20px",
                            fontSize: "1em",
                          }}
                        >
                          {item.ASSURANCE_ID} ({item.LEGACY_ASSURANCE_ID})
                        </td>
                      ) : (
                        <td
                          style={{
                            width: "40%",
                            textAlign: "left",
                            lineHeight: "20px",
                            fontSize: "1em",
                          }}
                        >
                          {item.ASSURANCE_ID}
                        </td>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Result;
